import styled from 'styled-components'

export const Highlight = styled.span`
  color: white
`
